<template>
    <div class="vacancies-card">
        <vue-headful :title="$t('my_responds')" />
        <div
            style="cursor: pointer"
            class="flex back-div mb-5 cursor-pointer"
            @click="goBack()"
        >
            <feather-icon class="cursor-pointer" icon="ArrowLeftIcon" />
            <span>{{ $t("return_back") }}</span>
        </div>
        <!-- <div class="flex mb-10">
            <vs-button
                ref="loadableButton"
                id="my-cvs-button"
                class="vs-con-loading__container w-full mr-4"
                @click="showMyCVsPopup()" >
                    {{ $t('my_cv_s') }}
                </vs-button>
            <vs-button type="border" color="success" class="w-full">{{ $t('my_responds') }}</vs-button>
        </div> -->

        <div
            id="todo-app"
            class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden"
        >
            <vs-sidebar
                class="items-no-padding"
                parent="#todo-app"
                :click-not-close="clickNotClose"
                :hidden-background="clickNotClose"
                v-model="isSidebarActive"
            >
                <!-- ФИЛЬТРЫ -->
                <ListFilters :sidebarToggle="toggleSidebar" ref="ListFilters" @closesidebar="toggleSidebar" />
            </vs-sidebar>

            <div
                :class="{ 'sidebar-spacer': clickNotClose }"
                class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content"
            >
                <div
                    class="infinite_header flex d-theme-dark-bg items-center border border-l-0 border-r-0 border-t-0 border-solid d-theme-border-grey-light"
                >
                    <!-- TOGGLE SIDEBAR BUTTON -->
                    <feather-icon
                        class="md:inline-flex lg:hidden ml-4 mr-2 lg:mr-4 cursor-pointer"
                        icon="MenuIcon"
                        @click.stop="toggleSidebar(true)"
                    />
                    <vs-input
                        class="px-2 lg:px-5 py-2 w-full"
                        icon="search"
                        icon-after="true"
                        :placeholder="$t('search_by_name')"
                        v-model="serch_by_name"
                    />
                </div>
                <VuePerfectScrollbar
                    id="div-with-loading"
                    class="vs-con-loading__container scroll-area empl_scroll"
                    :settings="settings"
                >
                    <div>
                        <ul v-if="vacancies.length">
                            <li
                                class="todo_todo-item cursor-pointer px-2 lg:px-5 pt-2 pb-2 lg:pt-3 lg:pb-3"
                                v-for="(item, index) in responds"
                                :style="[
                                    { transitionDelay: index * 0.1 + 's' },
                                ]"
                                :key="index"
                            >
                                <RespondPage :item="item" />
                            </li>
                        </ul>

                        <!-- Выводим сообщение если данных нет -->
                        <div class="mt-4 ml-5 mr-5" v-if="!vacancies.length">
                            <vs-alert active="true">
                                {{ $t("no_data_text") }}
                            </vs-alert>
                        </div>
                    </div>

                    <!-- В этот див выводил лоадер -->
                    <!-- <div id="infinite_loader" class="vs-con-loading__container"></div>

                        <div class="edited_dummy"></div> -->
                </VuePerfectScrollbar>
            </div>
        </div>
        <my-cv-popup v-bind="MyCVPopup" @close="closeMyCVsPopup" />
        <div class="mobile_dummy"></div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import MyCVs from "./Popups/MyCVs";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ListFilters from "./ListFilters.vue";
import RespondPage from "./RespondPage.vue";
export default {
    data() {
        return {
            responds: [],
            serch_by_name: "",
            isSidebarActive: true,
            loading: false,
            emptyMessage: false,
            clickNotClose: true,
            infiniteStatus: true,
            settings: {
                maxScrollbarLength: 120,
                wheelSpeed: 0.6,
            },
            MyCVPopup: {
                active: false,
                data: null,
            },
        };
    },
    watch: {
        windowWidth() {
            this.setSidebarWidth();
        },
    },
    components: {
        "my-cv-popup": MyCVs,
        VuePerfectScrollbar,
        ListFilters,
        RespondPage,
    },
    computed: {
        windowWidth() {
            return this.$store.state.windowWidth;
        },
        ...mapGetters({
            studentCVs: "employment/getSudentSVs",
            vacancies: "employment/getVacancies",
        }),
    },
    methods: {
        ...mapActions({
            getstudentCVs: "employment/getstudentCVs",
            getVacancies: "employment/getVacancies",
            getResponds: "employment/getMyResponds",
        }),
        goBack() {
            this.$router.push({
                name: "employment",
            });
        },
        closeMyCVsPopup() {
            this.MyCVPopup.active = false;
        },
        async showMyCVsPopup() {
            this.$vs.loading({
                container: "#my-cvs-button",
                scale: 0.45,
            });
            await this.getstudentCVs();
            this.$vs.loading.close("#my-cvs-button > .con-vs-loading");
            this.MyCVPopup.data = this.studentCVs;
            this.MyCVPopup.active = true;
        },
        toggleSidebar(value = false) {
            // Функция открытия sidebar с фильтрами для моб устройств
            if (!value && this.clickNotClose) return;
            this.isSidebarActive = value;
        },
        setSidebarWidth() {
            if (this.windowWidth < 992) {
                this.isSidebarActive = this.clickNotClose = false;
            } else {
                this.isSidebarActive = this.clickNotClose = true;
            }
        },
        async init() {
            this.$vs.loading({
                container: "#div-with-loading",
                scale: 0.6,
            });
            await this.getVacancies();

            const data = await this.getResponds();
            this.responds = data;
            this.$vs.loading.close("#div-with-loading > .con-vs-loading");
        },
    },
    mounted() {
        this.init();
        this.setSidebarWidth();
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/todo.scss";
.empl_scroll{
    height: calc(100% - 56.39px);
}
#infinite_loader {
    padding: 20px 0;
    .con-vs-loading {
        background: transparent;
    }
}
.infinite_header {
    min-height: 56.4px;
}
.back-div {
    display: flex;
    align-items: center;
}
@media only screen and (max-width: 800px) {
    .mobile_dummy{
        padding-top: 50px;
    }
}
</style>
